import { useState } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { API, api, waLink, openWa } from "@/lib/api";
import { Logo } from "./Nav";
import { HELLO } from "./Redes";

const AMTS = [[50000, "$50.000"], [100000, "$100.000"], [250000, "$250.000"], [500000, "$500.000"], [0, "Otro valor"]];
const IMP = { 50000: "Cubre el transporte de un deportista a un torneo regional.", 100000: "Financia una sesión grupal de educación emocional.", 250000: "Equipa a un deportista con implementos de entrenamiento.", 500000: "Aporta a una beca deportiva y académica.", 0: "Cualquier valor suma. Cuéntanos cuánto quieres aportar." };

export const Donar = () => {
  const { settings: s } = useSettings();
  const [amount, setAmount] = useState(100000);
  const text = amount ? `Hola, quiero donar $${amount.toLocaleString("es-CO")} COP a la Fundación Once y Once.` : "Hola, quiero hacer un aporte a la Fundación Once y Once.";
  const pay = [["Banco", s.banco], ["Cuenta", s.cuenta], ["Llave Bre-B", s.llave], ["NIT", s.nit]];
  return (
    <section id="donar" data-testid="donar-section">
      <div className="wrap donate">
        <div className="reveal">
          <h2>Apoya a un talento del sur de Barranquilla</h2>
          <p className="lead" style={{ marginTop: 16 }}>Tu aporte se convierte en implementos, transporte a torneos, acompañamiento psicológico y becas.</p>
          <div className="amts" role="group" aria-label="Elige tu aporte">
            {AMTS.map(([v, l]) => (<button key={v} className="amt" aria-pressed={amount === v} onClick={() => setAmount(v)} data-testid={`donar-amt-${v}`}>{l}</button>))}
          </div>
          <p style={{ color: "#fff" }} data-testid="donar-impact">{IMP[amount]}</p>
          <a className="btn btn-sol" href={waLink(s.whatsapp, text)} target="_blank" rel="noopener noreferrer" data-testid="donar-whatsapp-btn">Confirmar aporte por WhatsApp</a>
        </div>
        <aside className="pay reveal" data-testid="donar-pay-data">
          <h3>Datos para tu aporte</h3>
          <dl>
            {pay.map(([k, v]) => (<div key={k} style={{ display: "contents" }}><dt>{k}</dt><dd data-testid={`pay-${k}`}>{v || "Por confirmar"}</dd></div>))}
            <dt>Código QR</dt><dd data-testid="pay-qr-status">{s.qr ? "Escanéalo desde tu app bancaria" : "Por confirmar"}</dd>
          </dl>
          {s.qr && <img className="qr" src={`${API}/settings/qr/image?v=${s.qr_version}`} alt="Código QR para donar" data-testid="pay-qr-image" />}
          <p style={{ fontSize: ".9rem", color: "#6B6A6A", margin: "16px 0 0" }}>Envíanos el comprobante por WhatsApp y te enviamos tu certificado de donación.</p>
        </aside>
      </div>
    </section>
  );
};

const F0 = { nombre: "", institucion: "", tipo: "Colegio", telefono: "", mensaje: "" };

export const Contacto = () => {
  const { settings } = useSettings();
  const [f, setF] = useState(F0);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    const msg = `Hola, soy ${f.nombre}${f.institucion ? " de " + f.institucion : ""} (${f.tipo}).\n${f.mensaje || "Quiero información sobre los programas."}\nTel: ${f.telefono || "-"}`;
    openWa(waLink(settings.whatsapp, msg));
    api.post("/contact", f).then(() => setF(F0)).catch(() => {});
  };
  return (
    <section className="light" id="contacto" data-testid="contacto-section">
      <div className="wrap">
        <div className="head reveal"><h2>Hablemos</h2><p className="lead" style={{ margin: 0 }}>Colegios, academias, grupos culturales, empresas y familias: te respondemos por WhatsApp.</p></div>
        <form className="form" onSubmit={submit} data-testid="contact-form">
          <label>Nombre<input value={f.nombre} onChange={set("nombre")} required autoComplete="name" maxLength={120} data-testid="contact-nombre-input" /></label>
          <label>Institución o empresa<input value={f.institucion} onChange={set("institucion")} maxLength={160} data-testid="contact-institucion-input" /></label>
          <label>Soy
            <select value={f.tipo} onChange={set("tipo")} data-testid="contact-tipo-select">
              {["Colegio", "Academia deportiva", "Artista o grupo musical", "Empresa / patrocinador", "Deportista o familia"].map((o) => <option key={o}>{o}</option>)}
            </select>
          </label>
          <label>Teléfono<input value={f.telefono} onChange={set("telefono")} type="tel" autoComplete="tel" maxLength={40} data-testid="contact-telefono-input" /></label>
          <label className="full">Mensaje<textarea value={f.mensaje} onChange={set("mensaje")} maxLength={3000} placeholder="Ej.: queremos un taller de educación emocional para 40 jugadores sub-15" data-testid="contact-mensaje-input"></textarea></label>
          <div className="full"><button className="btn btn-navy" type="submit" data-testid="contact-submit-btn">Enviar por WhatsApp</button></div>
        </form>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { settings } = useSettings();
  return (
    <>
      <footer data-testid="site-footer">
        <div className="wrap">
          <div><div className="logo" style={{ color: "#fff", marginBottom: 10 }}><Logo dark /></div>Fundación Once y Once · Barranquilla, Atlántico, Colombia<br /><a href="mailto:fundaciononceyonce@gmail.com" data-testid="footer-email">fundaciononceyonce@gmail.com</a></div>
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            <a href="https://www.instagram.com/fundacion1111/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram">Instagram</a>
            <a href="/#donar" data-testid="footer-donar">Donar</a><a href="/#juegos" data-testid="footer-juegos">Juegos</a><a href="/#contacto" data-testid="footer-contacto">Contacto</a>
            <Link to="/equipo" data-testid="footer-equipo">Equipo</Link>
          </div>
          <div>© {new Date().getFullYear()} Fundación Once y Once · #ApoyemosElDeporte</div>
        </div>
      </footer>
      <a className="wa" href={waLink(settings.whatsapp, HELLO)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="whatsapp-float-btn">
        <svg width="30" height="30" viewBox="0 0 36 36"><path d="M8 29l1.6-5.7A11.5 11.5 0 1 1 13.8 27.4z" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinejoin="round" /><path d="M14 12.5c.5-.9 1.3-.8 1.6 0l.9 2.2c.1.4 0 .7-.3 1l-.6.7c.8 1.6 2.1 2.9 3.8 3.7l.7-.7c.3-.3.7-.3 1-.2l2.2 1c.7.3.8 1.1 0 1.7-1.6 1.3-3.6.9-6-.9-2.6-2-3.9-4.4-3.3-8.5z" fill="#fff" /></svg>
      </a>
    </>
  );
};
